import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-license-suspended-modal',
  templateUrl: './license-suspended-modal.component.html',
  styleUrls: ['./license-suspended-modal.component.scss'],
  standalone: false,
})
export class LicenseSuspendedModalComponent {

  constructor(public activeModal: NgbActiveModal) {
  }
}